export default function SectionIntro({ number, kicker, title, description }) {
  return (
    <div className="section-intro">
      <div className="section-number" aria-hidden="true">{number}</div>
      <div className="section-copy">
        <div className="section-kicker">{kicker}</div>
        <h2 className="section-title">{title}</h2>
        <p className="section-description">{description}</p>
      </div>
    </div>
  );
}
